import { gql } from 'apollo-boost'

const HTML_MENU_SCRAPING_SESSION_REPORT_URL = gql`
  query htmlMenuScrapingSessionReportUrl($id: ID!) {
    htmlMenuScrapingSessionReportUrl(id: $id)
  }
`

export default HTML_MENU_SCRAPING_SESSION_REPORT_URL
